import Ellipse1 from '../../components/public/touchone/ellipse13534366-h1ms.svg'
import Ellipse2 from '../../components/public/touchone/ellipse13534367-x809.svg'
import Back1 from '../../components/public/background/Background TouchOne/1.png'
import Back2 from '../../components/public/background/Background TouchOne/2.png'
import Back3 from '../../components/public/background/Background TouchOne/3.png'
import Back4 from '../../components/public/background/Background TouchOne/4.png'
import BackFiguras1 from '../../components/public/background/Background TouchOne/Figuras/1.png'
import BackFiguras2 from '../../components/public/background/Background TouchOne/Figuras/2.png'
import BackFiguras3 from '../../components/public/background/Background TouchOne/Figuras/3.png'
import image1414536 from '../../components/public/park/image1414536-q97-200w.png'
import Image1 from '../../components/public/imagens sistema/TouchOne/Image1.png'
import Image2 from '../../components/public/imagens sistema/TouchOne/Image2.png'
import Image3 from '../../components/public/imagens sistema/TouchOne/Image3.png'
import Image4 from '../../components/public/imagens sistema/TouchOne/Image4.png'
import './autoComTouchOne.css'
import './background.css'
import { IconsGrande, IconsPequeno } from '../../components/icons-sistema/icons-sistema'
import { useKeenSlider } from 'keen-slider/react'
import Venda from '../../components/public/pdv/group480879-ci.svg'
import Controle from '../../components/public/icons/Restantes/Controle.svg'
import Receba from '../../components/public/icons/Restantes/Receba.svg'
import CupomNfce from '../../components/public/pdv/cupom-sat-nfe.svg'
import WhiteLabel from '../../components/public/pdv/white-label.png'
import SuporteTecnico from '../../components/public/pdv/suporte-tecnico.png'
import Group1222 from '../../components/public/touchone/Group 1222.png'
import Seguranca from '../../components/public/touchone/seguranca.svg'
import Liberdade from '../../components/public/touchone/liberdade.svg'
import MobileMaq from '../../components/public/touchone/mobile-maq.png'
import TotemTouchOne from '../../components/public/touchone/totem touchone.png'
import { Link } from 'react-router-dom'
import { QrCode } from '../../components/qrcode/qrcode'
import { useSessaoAtual } from '../../../services/providers/sessao-atual-provider/sessao-atual-provider'
import { useHistory } from 'react-router'
import { Footer } from '../../components/footer/footer'
import LogoLoja from '../../components/public/touchone/Logo de Lojas de moda feminina 1.png'
import { Helmet } from 'react-helmet'
import MenuIcon from '@material-ui/icons/Menu';
import { Box, Divider, Button, IconButton, List, ListItemIcon, SwipeableDrawer, Toolbar, useTheme, Typography } from '@material-ui/core'
import { useState } from 'react'
import clsx from 'clsx';
import ChevronLeftIcon from "@material-ui/icons/ChevronLeft";
import ChevronRightIcon from "@material-ui/icons/ChevronRight";
import ListItem from "@material-ui/core/ListItem";
import { useStyles } from './touchone-style'
import { BaixasStorageKeys, useBaixasStorage } from '../../../services/use-cases/baixas-storage'

export const SaurusTouchOne = () => {

    const { DefinirRota, IsValidSession, Logout } = useSessaoAtual()
    DefinirRota('/touchone')
    const classes = useStyles()
    const theme = useTheme();
    const history = useHistory()
    const [open, setOpen] = useState(false);
    const { getRegister } = useBaixasStorage();
    const user = getRegister(BaixasStorageKeys.data)

    const handleDrawerOpen = () => {
        setOpen(true);
    };

    const toggleDrawer = (open: boolean) => (
        event: React.KeyboardEvent | React.MouseEvent,
    ) => {
        if (
            event &&
            event.type === 'keydown' &&
            ((event as React.KeyboardEvent).key === 'Tab' ||
                (event as React.KeyboardEvent).key === 'Shift')
        ) {
            return;
        }

        setOpen(false);
    };

    const handleDrawerClose = () => {
        setOpen(false);
    };
    if (!IsValidSession) history.push('/')
    const [refCallback] = useKeenSlider(
        {
            slides: { perView: 'auto', spacing: 10 },
        },
        [
            // add plugins here
        ]
    )

    return (
        <>
            {user.id ?
                <>
                    <Toolbar className={classes.appBar}>
                        <IconButton
                            color="inherit"
                            aria-label="open drawer"
                            onClick={handleDrawerOpen}
                            edge="start"
                            className={clsx(classes.menuButton, open && classes.hide)}
                        >
                            <MenuIcon className={classes.menuButton} />
                            <Typography style={{ fontSize: '17px', padding: '0 15px' }} variant="h4">
                                TouchOne
                            </Typography>
                        </IconButton>
                        {/* <QrCode backColor="#386D9F" /> */}
                    </Toolbar>
                    <SwipeableDrawer
                        className={classes.drawer}
                        classes={{
                            paper: classes.drawerPaper
                        }}
                        open={open}
                        anchor={'left'}
                        onClose={toggleDrawer(false)}
                        onOpen={toggleDrawer(true)}
                    >
                        <div className={classes.drawerHeader}>
                            <Typography style={{ fontSize: '17px', padding: '0px 85px 0 0' }} variant="h4">
                                Saurus TouchOne
                            </Typography>
                            <IconButton onClick={handleDrawerClose}>
                                {theme.direction === "ltr" ? (
                                    <ChevronLeftIcon />
                                ) : (
                                    <ChevronRightIcon />
                                )}
                            </IconButton>
                        </div>
                        <Divider />
                        <div style={{ backgroundColor: '#fafafa' }}>
                            <List >
                                <ListItem button className={classes.listFilho}>
                                    <ListItemIcon onClick={() => history.push('/cadastrar')}>
                                        Cadastrar-se
                                    </ListItemIcon>
                                </ListItem>
                            </List>
                            <Divider />
                            <ListItem button className={classes.list} >
                                <ListItemIcon onClick={() => history.push('/representante')}>
                                    Representante
                                </ListItemIcon>
                            </ListItem>
                        </div>
                        <Box flexGrow={1} bgcolor='#fafafa' />  {/* jogou o sair para baixo */}
                        <Divider classes={{ root: classes.divider }} />
                        <ListItem button className={classes.list} >
                            <ListItemIcon onClick={() => history.push('/login')}>
                                Sair
                            </ListItemIcon>
                        </ListItem>
                    </SwipeableDrawer>
                </>

                :
                <>
                    <div style={{ padding: '8px 8px', display: 'flex', justifyContent: 'space-between' }}>
                        <Button variant='outlined' style={{ backgroundColor: '#1F9CE4', zIndex: 1, color: '#fff' }} onClick={() => history.push('/login')}>Logar</Button>
                        <Button variant='outlined' style={{ backgroundColor: '#1F9CE4', zIndex: 1, color: '#fff' }} onClick={() => history.push('/representante')}>Representante</Button>
                    </div>
                </>
            }
            <div className="saurusTouchOnePage">
                <Helmet>
                    <title>Saurus TouchOne - Saurus AutoCom</title>
                    <meta content="#1F9CE4" name="theme-color" />
                </Helmet>
                <img src={Back1} alt="" className="background1" />
                <img src={Back2} alt="" className="background2" />
                <img src={Back3} alt="" className="background3" />
                <img src={Back4} alt="" className="background4" />
                <img src={BackFiguras1} alt="" className="background-figuras1" />
                <img src={BackFiguras2} alt="" className="background-figuras2" />
                <img src={BackFiguras3} alt="" className="background-figuras3" />
                <div className="p-d-v1430-container">
                    <div className="p-d-v1430-p-d-v1430">
                        {user.id ?
                            <div className="p-d-v1430-group11911453" >
                            </div>
                            :
                            <div className="saurusTouchOnePage .p-d-v1430-group45218" >
                            </div>
                        }
                        <div className="sliders">
                            <div id="my-keen-slider" ref={refCallback} className="keen-slider">
                                <div className="keen-slider__slide slide-servicos-grande">
                                    <img src={IconsGrande().TouchOneGrande} alt="Rectangle882131182" className="p-d-v1430-image25" />
                                </div>
                                <div className="keen-slider__slide slide-servicos">
                                    <Link to="/saurus-pdv">
                                        <img src={IconsPequeno().PDVPequeno} alt="Rectangle882131182" className="p-d-v1430-image25" />
                                    </Link>
                                </div>
                                <div className="keen-slider__slide slide-servicos">
                                    <Link to="/saurus-v4">
                                        <img src={IconsPequeno().V4Pequeno} alt="Rectangle882131182" className="p-d-v1430-image25" />
                                    </Link>
                                </div>
                                <div className="keen-slider__slide slide-servicos">
                                    <Link to="/saurus-mobile">
                                        <img src={IconsPequeno().MobilePequeno} alt="Rectangle882131182" className="p-d-v1430-image25" />
                                    </Link>
                                </div>
                            </div>
                        </div>
                        <div className="container">
                            <hr className="hr-cinza" />
                        </div>
                        <div className="container">
                            <div className="row">
                                <div className="col-lg-7 col-12">
                                    <div className="p-d-v1430-conheao-saurus-p-d-v15174">
                                        <span className="p-d-v1430-text02">
                                            <span className="p-d-v1430-text03">Conheça o</span>
                                            <div className="text-saurus-pdv">
                                                <span className="p-d-v1430-text04">Touch<span className="p-d-v1430-text08">One</span></span>
                                            </div>
                                        </span>
                                    </div>
                                    <div className="content-sistema-versatil">
                                        <span className="p-d-v1430-text38">
                                            <span className="p-d-v1430-text39">A solução de vendas que veio para </span>
                                            <span className="p-d-v1430-text40">simplificar </span>
                                            <span className="p-d-v1430-text39">a </span>
                                            <span className="p-d-v1430-text39"><span className="p-d-v1430-text40">gestão de negócios</span>. </span>
                                            <span className="p-d-v1430-text39">Sua operação altamente </span>
                                            <span className="p-d-v1430-text40">intuitiva </span>
                                            <span className="p-d-v1430-text39">já vem integrada aos </span>
                                            <span className="p-d-v1430-text40">meios de pagamento.</span>
                                        </span>
                                    </div>
                                </div>
                                <div className="col-lg-5 d-none-celular">
                                    <div className="d-flex justify-content-center">
                                        <img src={MobileMaq} className="mobile-maq" alt="" />
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="container icons-content">
                            <div className="row">
                                <div className="col-6 col-md-3">
                                    <div className="p-d-v1430-frentedecaixa11839">
                                        <div className="imagem70">
                                            <img src={Venda} alt="Group480879" className="p-d-v1430-image07" />
                                        </div>
                                        <span className="p-d-v1430-text09">
                                            <span className="p-d-v1430-text10">VENDA</span>
                                        </span>
                                    </div>
                                </div>
                                <div className="col-6 col-md-3">
                                    <div className="p-d-v1430-cupom-s-a-t-n-f-ce11850">
                                        <img src={Receba} alt="Group4721012" className="p-d-v1430-image22" />
                                        <span className="p-d-v1430-text33">
                                            <span className="p-d-v1430-text34">
                                                <span>RECEBA</span>
                                            </span>
                                        </span>
                                    </div>
                                </div>
                                <div className="col-6 col-md-3">
                                    <div className="p-d-v1430-retaguardalocal11847">
                                        <img src={CupomNfce} alt="Group4721050" className="p-d-v1430-image21" />
                                        <span className="p-d-v1430-text31">
                                            <span className="p-d-v1430-text32">CUPOM NFC-E</span>
                                        </span>
                                    </div>
                                </div>
                                <div className="col-6 col-md-3">
                                    <div className="p-d-v1430-retaguardalocal11847">
                                        <img src={Controle} alt="Group4721050" className="p-d-v1430-image21" />
                                        <span className="p-d-v1430-text31">
                                            <span className="p-d-v1430-text32">CONTROLE</span>
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div id="my-keen-sliderr" ref={refCallback} className="keen-slider container">
                            <div className="keen-slider__slide slide-imagens">
                                <a href={Image1} rel="noreferrer" target="_blank">
                                    <img src={Image1} alt="Rectangle882131182" className="p-d-v1430-image25" />
                                </a>
                            </div>
                            <div className="keen-slider__slide slide-imagens">
                                <a href={Image2} rel="noreferrer" target="_blank">
                                    <img src={Image2} alt="Rectangle882131182" className="p-d-v1430-image25" />
                                </a>
                            </div>
                            <div className="keen-slider__slide slide-imagens">
                                <a href={Image3} rel="noreferrer" target="_blank">
                                    <img src={Image3} alt="Rectangle882131182" className="p-d-v1430-image25" />
                                </a>
                            </div>
                            <div className="keen-slider__slide slide-imagens">
                                <a href={Image4} rel="noreferrer" target="_blank">
                                    <img src={Image4} alt="Rectangle882131182" className="p-d-v1430-image25" />
                                </a>
                            </div>
                        </div>
                        <div className="container">
                            <hr className="hr-cinza" />
                        </div>
                        <div className="container">
                            <div className="row">
                                <div className="col-lg-6 col-12">
                                    <div className="p-d-v1430-text48">
                                        <span className="p-d-v1430-text547">
                                            <span><span className="p-d-v1430-text54">Vendas rápidas</span>, com </span>
                                            <span className="p-d-v1430-text54">poucos toques.</span>
                                        </span>
                                    </div>
                                    <span className="p-d-v1430-text87">
                                        <span className="p-d-v1430-text88">Retaguarda </span>
                                        <span className="p-d-v1430-text89">online </span>
                                        <span className="p-d-v1430-text90">que pode ser acessada de qualquer </span>
                                        <span className="p-d-v1430-text89">computador </span>
                                        <span className="p-d-v1430-text90">ou </span>
                                        <span className="p-d-v1430-text89">smartphone.</span>
                                    </span>
                                    <div className="row">
                                        <div className="col-lg-6 col-12">
                                            <div className="pdv-maquininha mt-4">
                                                <img src={Group1222} alt="Group4721050" className="max-width-100 p-d-v1430-image21" />
                                            </div>
                                        </div>
                                        <div className="col-lg-6 col-12 d-flex align-items-center">
                                            <div className="mt-4 mb-5">
                                                <div className="row mb-4">
                                                    <div className="col-2">
                                                        <img src={Seguranca} alt="Group4721050" className="p-d-v1430-image21" />
                                                    </div>
                                                    <div className="col-10 cate-alinhar">
                                                        <div className='ms-2'>
                                                            <span className="p-d-v1430-text89">Segurança</span><br />
                                                            <span className="p-d-v1430-text90">Vendas integradas à carteira digital.</span>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="row">
                                                    <div className="col-2">
                                                        <img src={Liberdade} alt="Group4721050" className="p-d-v1430-image21" />
                                                    </div>
                                                    <div className="col-10 cate-alinhar">
                                                        <div className='ms-2'>
                                                            <span className="p-d-v1430-text89">Liberdade</span><br />
                                                            <span className="p-d-v1430-text90">Acesso e controle das vendas de qualquer dispositivo.</span>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-lg-6 d-none-celular">
                                    <div className="row">
                                        <div className="col-lg-7">
                                            <div>
                                                <span className="versao-autoatendimento">
                                                    <span>Disponível</span> em versão <span>Autoatendimento</span>.
                                                </span>
                                            </div>
                                            <div className="d-flex justify-content-end mb-5">
                                                <img src={LogoLoja} className="img-fluid" alt="" />
                                            </div>
                                            <div className="d-flex mb-5">
                                                <img src={WhiteLabel} className="img-white-label" alt="" />
                                                <div>
                                                    <span className="white-suporte">WHITE LABEL</span>
                                                    <br />
                                                    <span className="white-suporte-texto">
                                                        O <span>SAURUS PDV</span> também
                                                        permite customização para
                                                        que o sistema tenha a
                                                        identidade da sua marca!
                                                    </span>
                                                </div>
                                            </div>
                                            <div className="d-flex">
                                                <img src={SuporteTecnico} className="img-suporte-tecnico" alt="" />
                                                <div className="ms-3">
                                                    <span className="white-suporte">SUPORTE TÉCNICO</span>
                                                    <br />
                                                    <span className="white-suporte-texto">
                                                        Equipe <span>especializada</span>
                                                        no atendimento à
                                                        revendedores.
                                                    </span>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-lg-5">
                                            <img src={TotemTouchOne} className="img-fluid" alt="" />
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="row d-none-celular pb-3">
                                <div className="col-5">
                                    <a className="p-d-v1430-acessarpelogoogle11163" rel='noreferrer noopener' href='https://saurus.blob.core.windows.net/autocom/TOUCHONE.pdf' target="_blank">
                                        <img src={image1414536} alt="image1414536" className="p-d-v1430-image36" />
                                        <span className="p-d-v1430-text60">PDF</span>
                                    </a>
                                </div>
                                <div className="col-5">
                                    <a className="p-d-v1430-adicionar406885" href="https://saurus.com.br/touch-one/">
                                        <span className="p-d-v1430-text62">Mais informações</span>
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="container d-none-pc pb-3">
                        <a className="p-d-v1430-acessarpelogoogle11163" rel='noreferrer noopener' href='https://saurus.blob.core.windows.net/autocom/TOUCHONE.pdf' target="_blank">
                            <img src={image1414536} alt="image1414536" className="p-d-v1430-image36" />
                            <span className="p-d-v1430-text60">PDF</span>
                        </a>
                        <a className="p-d-v1430-adicionar406885" href="https://saurus.com.br/touch-one/" target="_blank" rel="noreferrer">
                            <span className="p-d-v1430-text62">Mais informações</span>
                        </a>
                    </div>
                    <Footer />
                </div>
            </div>
        </>
    )
}